/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `ingredient` - Ingredient
* `purchased_good` - Purchased good
* `product` - Product
 */
export type LinkedItemTypeEnum = typeof LinkedItemTypeEnum[keyof typeof LinkedItemTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LinkedItemTypeEnum = {
  ingredient: 'ingredient',
  purchased_good: 'purchased_good',
  product: 'product',
} as const;
